import { returnDate } from "../../../../../utils/formatDate"

export function DatesComponent({ value }) {
    return (
        <div className="bg-white rounded-lg shadow p-6">
            <h3 className="text-lg font-semibold text-gray-800 mb-4 flex items-center">
                <i className="fas fa-history mr-2 text-indigo-600 mr-4"></i> Datas
            </h3>

            <div className="space-y-4">
                <div className="flex items-start">
                    <div className="w-6 h-6 rounded-full bg-indigo-100 flex items-center justify-center mr-3 mt-1 flex-shrink-0">
                        <i className="fas fa-plus text-indigo-600 text-xs"></i>
                    </div>
                    <div>
                        <p className="text-sm font-medium text-gray-800">Chamado criado</p>
                        <p className="text-xs text-gray-500">{returnDate(value.creationDate)}</p>
                    </div>
                </div>

                {value.taskStartTime !== null &&
                    <div className="flex items-start">
                        <div className="w-6 h-6 rounded-full bg-indigo-100 flex items-center justify-center mr-3 mt-1 flex-shrink-0">
                            <i className="fas fa-headset text-indigo-600 text-xs"></i>
                        </div>
                        <div>
                            <p className="text-sm font-medium text-gray-800">Técnico assumiu</p>
                            <p className="text-xs text-gray-500">{returnDate(value.taskStartTime)}</p>
                        </div>
                    </div>
                }

                {value.updateDate !== null &&
                    <div className="flex items-start">
                        <div className="w-6 h-6 rounded-full bg-green-100 flex items-center justify-center mr-3 mt-1 flex-shrink-0">
                            <i className="fas fa-tag text-green-600 text-xs"></i>
                        </div>
                        <div>
                            <p className="text-sm font-medium text-gray-800">Chamado finalizado</p>
                            <p className="text-xs text-gray-500">{returnDate(value.updateDate)}</p>
                        </div>
                    </div>
                }
            </div>
        </div>
    )
}